import React, {Component} from 'react'
import moment from 'moment'
import {Button, Card, Col, DatePicker, Divider, Drawer, notification, Row, Select} from 'antd'
import {hideLoader, showLoader} from '../../../modules/actions'

import Request from '../../../request'
import {connect} from 'react-redux'

class ApplicationOfferExpectedDate extends Component {
    state = {
        offerExpDate: null,
        choosenCourseId: '',
        visible: true
    }


    componentWillReceiveProps(nextProps, nextContext) {

    }

    componentDidMount = async () => {


        const {offerExpDate, courseId} = this.props
        this.setState({offerExpDate, courseId})

    }


    save = async () => {


        const {dispatch} = this.props
        let obj = {
            ...this.state
        }


        if (!obj.offerExpDate) {
            return notification.warning({
                message: 'Choose Offer Expect Date'
            })
        }
        obj.inquiryId = this.props.inquiryId
        dispatch(showLoader())
        let x = await Request.updateApplicationOfferExpectedDate(obj)
        dispatch(hideLoader())
        if (x && x.success) {
            this.onClose()
            return notification.success({
                message: x.msg
            })

        } else {
            return notification.error({
                message: 'Try again'
            })
        }

    }


    show = () => {

        this.setState({visible: true})
    }

    onClose = () => {
        this.setState({
            visible: false
        })
        this.props.onClose()
    }
    callback = value => {

        this.props.callback()
    }


    render() {
        let {offerExpDate} = this.state

        return (
            <Drawer
                title={'Offer Expected Date'}
                placement={'right'}
                width={1000}
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}>
                <div>

                    <Card>
                        <Row>

                            <Col span={24} style={{paddingLeft: 10, border: 1}}>

                                <React.Fragment>
                                    <div>
                                        <h4>OFFER EXPECTED DATE</h4>
                                        <DatePicker format={'DD-MMM-YYYY'}
                                                    value={moment(offerExpDate)}
                                            // disabledDate={d => !d || d.isBefore(moment().add(-1, 'day'))}
                                                    onChange={(v) => {
                                                        this.setState({offerExpDate: v})
                                                    }}
                                        />
                                    </div>
                                    <Divider/>

                                    <Row>
                                        <Col span={12}><Button type={'primary'} loading={this.props.loading}
                                                               onClick={() => this.save()}>
                                            UPDATE </Button></Col>

                                    </Row>
                                </React.Fragment>
                            </Col>

                        </Row>


                    </Card>


                </div>
            </Drawer>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,

    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ApplicationOfferExpectedDate)
